import { cn } from '@forest/shared'
import { motion } from 'motion/react'
import { native } from '~/services/native'

export function Page(props: {
  next: () => void
  children: React.ReactNode
  className?: string
  shouldHideSecondary?: boolean
  buttonText?: string
  dismissText?: string
  footerAddtional?: React.ReactNode
  onSecondaryClick?: () => void
  pageIndex: number
}) {
  const handleSecondaryClick =
    props.onSecondaryClick ??
    (() => {
      native.general.close()
    })

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={cn(
        'relative h-full overflow-y-auto px-8 pb-48 pt-[120px] font-[300]',
        props.className,
      )}
    >
      {props.children}

      <div
        id="footer"
        className="fixed bottom-0 left-0 right-0 z-30 bg-[#001721] px-6 pb-[calc(var(--safe-area-bottom)+16px)] pt-5 animate-in slide-in-from-bottom"
      >
        <div className="mx-auto flex w-full max-w-[640px] flex-col items-center gap-5">
          {props.footerAddtional}
          <NextButton next={props.next} buttonText={props.buttonText} />
          {!props.shouldHideSecondary && (
            <button
              className="text-xs font-light text-white/40 underline"
              onClick={handleSecondaryClick}
            >
              {props.dismissText ?? ''}
            </button>
          )}
        </div>

        <div className="absolute left-0 right-0 top-[-2px] flex gap-[15px]">
          <div
            className={cn(
              'h-[5px] flex-1 rounded-r-full bg-[rgba(152,255,223,.1)]',
              props.pageIndex > -1 && 'bg-[rgba(152,255,223,0.4)]',
            )}
          ></div>
          <div
            className={cn(
              'h-[5px] flex-1 rounded-full bg-[rgba(152,255,223,.1)]',
              props.pageIndex > 0 && 'bg-[rgba(152,255,223,0.4)]',
            )}
          ></div>
          <div
            className={cn(
              'h-[5px] flex-1 rounded-full bg-[rgba(152,255,223,.1)]',
              props.pageIndex > 1 && 'bg-[rgba(152,255,223,0.4)]',
            )}
          ></div>
          <div
            className={cn(
              'h-[5px] flex-1 rounded-l-full bg-[rgba(152,255,223,.1)]',
              props.pageIndex > 2 && 'bg-[rgba(152,255,223,0.4)]',
            )}
          ></div>
        </div>
      </div>
    </motion.div>
  )
}

function NextButton(props: { next: () => void; buttonText?: string }) {
  return (
    <button
      className="h-[52px] w-full rounded-xl p-[3px]"
      onClick={props.next}
      style={{
        backgroundImage: 'linear-gradient(80deg, #DCFFBF, #4EFFCA)',
      }}
    >
      <span className="flex h-full w-full items-center justify-center rounded-[11px] bg-gradient-to-r from-[#63FFD2] to-[#ADFFE7] font-bold text-[#054442]">
        {props.buttonText ?? ''}
      </span>
    </button>
  )
}
